import { render, staticRenderFns } from "./toolbar-select-menu.vue?vue&type=template&id=4a4cf0e1&"
import script from "./toolbar-select-menu.vue?vue&type=script&lang=js&"
export * from "./toolbar-select-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports